import Vue from 'vue'
import App from './App.vue'
import router from './router'

import store from './store'
import api from './store/api.js'
import 'lib-flexible'
import Login from '@/plugin/login/index.js'
import Toast from '@/plugin/toast/index.js'
import Address from '@/plugin/address/index.js'
import Confirm from '@/plugin/confirm/index.js'
import Alert from '@/plugin/alert/index.js'
import ServerRole from '@/plugin/server-role/index.js'
import '@/assets/css/common.css'


Vue.config.productionTip = false

Vue.prototype.$Api = api
Vue.use(Login)
Vue.use(Toast)
Vue.use(Address)
Vue.use(Confirm)
Vue.use(Alert)
Vue.use(ServerRole)
export default new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
